/**
 * /gift/cannot-stack — Shown when the recipient already has a paid tier
 * equal to or higher than the gifted tier (smart-accept stacking rule in
 * gift-redeem). Reads ?current=<tier>&gift=<tier> from the URL.
 */

import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MARKETING_URL } from "@/lib/urls";
import { PublicShell } from "@/components/PublicShell";

const TIER_LABELS: Record<string, string> = {
  seedling: "Seedling",
  ember: "Ember",
  keeper: "Keeper",
  storyteller: "Storyteller",
};

function tierLabel(slug: string): string {
  return TIER_LABELS[slug] ?? slug;
}

export default function GiftCannotStackPage() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const current = params.get("current") ?? "";
  const gift    = params.get("gift") ?? "";

  return (
    <PublicShell>
      <div className="flex flex-col items-center justify-center flex-1 px-6 py-16 text-center">
        <span className="text-5xl mb-6 block">🌰</span>

        <h1 className="text-2xl font-semibold text-foreground mb-4 leading-snug">
          {t("gift.cannotStack.title")}
        </h1>

        <p className="text-base text-muted-foreground leading-relaxed max-w-sm mb-3">
          {t("gift.cannotStack.body1", { current: tierLabel(current), gift: tierLabel(gift) })}
        </p>

        <p className="text-base text-muted-foreground leading-relaxed max-w-sm">
          {t("gift.cannotStack.body2Prefix")}{" "}
          <a
            href="mailto:hello@meetmori.app"
            className="text-foreground underline underline-offset-2"
          >
            hello@meetmori.app
          </a>{" "}
          {t("gift.cannotStack.body2Suffix")}
        </p>

        <div className="mt-10">
          <a
            href={MARKETING_URL}
            className="inline-block rounded-xl px-6 py-3 text-sm font-medium text-white transition-opacity hover:opacity-85"
            style={{ backgroundColor: "#7A9A7C" }}
          >
            {t("gift.backToMori")}
          </a>
        </div>
      </div>
    </PublicShell>
  );
}
